
import React from 'react'
import icon from './svgs/PrevSlide.svg'
import { BaseIcon } from './_base'

export const PreviousSlideIcon = ({ size, fontSize ,sx}) => {
    return (
        <BaseIcon icon = {icon} {...{fontSize,size,...sx}} />
    )
}
